<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs">
                <v-btn color="primary" v-bind="attrs" v-on="on">+ user</v-btn>
            </slot>
        </template>

        <v-card flat>
            <v-card-title class="flex-nowrap align-start">
                <div>
                    <div>Invite Instance Users</div>
                    <div class="text-body-2 font-weight-regular secondary--text">{{ instanceName }}</div>
                </div>
                <v-spacer />
                <v-btn :disabled="inviteActionState.loading" icon @click="closeDialog"><v-icon>clear</v-icon></v-btn>
            </v-card-title>
            <v-card-text :key="inviteRenderKey">
                <InstanceInvite
                    ref="instanceInvite"
                    :showInviteAction="false"
                    :dataForInstanceToInviteTo="{ instanceName }"
                    @invite-action-state="syncInviteActionState"
                    @invite-success="handleInviteSuccess" />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn :loading="inviteActionState.loading" :disabled="inviteActionState.disabled" color="primary" text @click="triggerInvite">Invite</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import InstanceInvite from '@/modules/instance/components/InstanceInvite.vue'

export default {
    name: 'InstanceInviteDialog',
    components: { InstanceInvite },
    props: {
        instanceName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            inviteRenderKey: 0,
            inviteActionState: {
                loading: false,
                disabled: true
            }
        }
    },
    methods: {
        openDialog() {
            this.dialog = true
        },
        closeDialog() {
            this.dialog = false
            this.inviteRenderKey += 1
            this.inviteActionState = { loading: false, disabled: true }
        },
        syncInviteActionState(state) {
            this.inviteActionState = {
                loading: Boolean(state?.loading),
                disabled: Boolean(state?.disabled)
            }
        },
        triggerInvite() {
            this.$refs.instanceInvite?.triggerInviteFromParent()
        },
        handleInviteSuccess() {
            this.$store.dispatch('instanceStore/fetchInstanceInvitations', this.$route.params.iid)
            this.closeDialog()
        }
    }
}
</script>
